import React, { useEffect, useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Timer, Save } from "lucide-react";
import { toast } from "sonner";

export default function LateToleranceCard() {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["late-tolerance"], queryFn: async () => (await api.get("/school-config/late-tolerance")).data });
  const [val, setVal] = useState("");
  useEffect(() => { if (data) setVal(String(data.minutes)); }, [data]);
  const save = useMutation({
    mutationFn: async () => (await api.put("/school-config/late-tolerance", { minutes: parseInt(val || "0", 10) })).data,
    onSuccess: (d) => { toast.success(`Tolleranza ritardo: ${d.minutes} minuti`); qc.invalidateQueries({ queryKey: ["late-tolerance"] }); },
    onError: (e) => toast.error(e.response?.data?.detail || "Errore"),
  });
  return (
    <Card className="border border-stone-200 rounded-xl shadow-none overflow-hidden" data-testid="late-tolerance-card">
      <div className="p-5 border-b border-stone-100 flex items-center gap-3">
        <div className="w-10 h-10 rounded-lg grid place-items-center text-white bg-orange-600"><Timer size={18}/></div>
        <div>
          <div className="font-medium text-[#1C352D]">Presenze — tolleranza ritardo</div>
          <div className="text-[11px] text-stone-500">Chi fa il check-in QR oltre questi minuti dall'ora di inizio della sessione viene registrato "in ritardo". Chi non scansiona resta assente.</div>
        </div>
      </div>
      <div className="p-5 flex items-end gap-3">
        <div className="max-w-[160px]">
          <label className="text-[10px] uppercase tracking-widest text-stone-500">Minuti</label>
          <Input type="number" min="0" max="180" value={val} onChange={(e) => setVal(e.target.value)} className="mt-1" data-testid="late-tolerance-input"/>
        </div>
        <Button onClick={() => save.mutate()} disabled={save.isPending} className="bg-[#1C352D] hover:bg-[#264A3E]" data-testid="late-tolerance-save">
          <Save size={13} className="mr-1.5"/> Salva
        </Button>
      </div>
    </Card>
  );
}
